module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "userNavigation"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.isActivityPage && _vm.isUserLoggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": _vm.searchLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-search searchIcon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.t('Last Search...')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLoggedIn && _vm.userType !== 'promoter') ? _c('li', {
    staticClass: "nav-item myBookingsMenuLink"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": ("/" + _vm.language + "/bookings")
    }
  }, [_vm._v(_vm._s(_vm.t('My Bookings')) + " "), (_vm.bookings.length > 0) ? _c('span', {
    staticClass: "badge badge-light"
  }, [_vm._v(_vm._s(_vm.bookings.length))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.totalUnpaidCount > 0 && _vm.isUserLoggedIn) ? _c('li', {
    staticClass: "nav-item paymentsMenuLink"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": ("/" + _vm.language + "/payment")
    }
  }, [_vm._v(_vm._s(_vm.t('Payments'))), _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(_vm._s(_vm.totalUnpaidCount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isActivityPage) ? _c('li', {
    staticClass: "nav-item CalendarAndBookingsMenuLink"
  }, [_c('i', {
    staticClass: "fa fa-calendar calendarIcon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.toggleCalendarOnTop()
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Calendar and Bookings')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "demoMessage"
  }, [_vm._v("This site exists for demonstration purposes only. All information contained has been randomly generated.")])]), _vm._v(" "), (_vm.totalUnpaidCount > 0 && _vm.$route.name !== 'User Payment') ? _c('div', {
    staticClass: "warnings text-xs-center"
  }, [_vm._v("\n    " + _vm._s(_vm.t('You have unpaid bookings')) + ". "), _c('router-link', {
    attrs: {
      "to": ("/" + _vm.language + "/payment")
    }
  }, [_vm._v(_vm._s(_vm.t('Go to payments')))])], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ef8acb40", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef8acb40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/UserNavigation.vue
// module id = 808
// module chunks = 3